import axios, { AxiosResponse } from 'axios' 
import { IBafModel } from './BafModel'
import { ApiResponse, PageResponse } from '../../../../shared/models/ApiModels'


const API_URL = (process.env.REACT_APP_API_URL || '/').replace(/\/?$/, '/')

export const BAF_CREATE_URL = `${API_URL}api/v1/definition/baf/create`
export const BAF_GET_ALL_URL = `${API_URL}api/v1/definition/baf/all`
export const BAF_DELETE_URL = `${API_URL}api/v1/definition/baf/delete/`
export const BAF_UPDATE_URL = `${API_URL}api/v1/definition/baf/update/`

export function createBaf(baf: IBafModel) {
  return axios.post(BAF_CREATE_URL, baf)
}

export async function loadBafs(
  page = 0, 
  size = 5, 
  sort: string = 'createdDate', 
  order: string = 'desc'
): Promise<AxiosResponse<ApiResponse<PageResponse<IBafModel>>>> {
  return axios.get(BAF_GET_ALL_URL, {
    params: { page, size, sort, order }
  });
}

export function deleteBaf(bafId: String) {
  return axios.delete(BAF_DELETE_URL + bafId)
}

export function updateBaf(baf: IBafModel) {
  return axios.patch(BAF_UPDATE_URL + baf.id, baf)
}
